import React from 'react';
import { createPortal } from 'react-dom';
import { TooltipProps } from './typescript';
const Tooltip: React.FC<TooltipProps> = ({
  isVisible,
  content,
  position,
  targetElement
}) => {
  if (!isVisible || !content) return null;
  const getTooltipPosition = () => {
    if (!targetElement) return {
      top: position.y - 50,
      left: position.x
    };
    const rect = targetElement.getBoundingClientRect();
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
    return {
      top: rect.top + scrollTop - 50,
      // 50px nad elementem
      left: rect.left + scrollLeft + rect.width / 2 // wyśrodkowany nad elementem
    };
  };
  const tooltipPosition = getTooltipPosition();
  return createPortal(<div style={{
    position: 'absolute',
    top: tooltipPosition.top,
    left: tooltipPosition.left,
    transform: 'translateX(-50%)',
    backgroundColor: '#4a4a4a',
    color: 'white',
    padding: '8px 12px',
    borderRadius: '6px',
    fontSize: '14px',
    lineHeight: '1.4',
    zIndex: 9999,
    maxWidth: '300px',
    wordWrap: 'break-word',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
    pointerEvents: 'none'
  }}>
      <div style={{
      textAlign: 'center'
    }}>{content}</div>
      {/* Strzałka wskazująca w dół */}
      <div style={{
      position: 'absolute',
      top: '100%',
      left: '50%',
      transform: 'translateX(-50%)',
      width: 0,
      height: 0,
      borderLeft: '6px solid transparent',
      borderRight: '6px solid transparent',
      borderTop: '6px solid #4a4a4a'
    }} />
    </div>, document.body);
};
export default Tooltip;